import { Component, Input } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
@Component({
  selector: 'app-svg',
  templateUrl: './svg.component.html',
  styleUrls: ['./svg.component.scss'],
  imports: [SvgIconComponent],
})
export class SvgComponent {
  @Input() public icon?: string;

  @Input() public svgStyle?: Record<string, any>;
}
